import { useEffect, useState } from "react";
import CommonAvatar from "./CommonAvatar";
const UserProfileWithCompany = ({
  userName: _userName = false,
  name,
  designation: _designation,
  UserImg,
  companyLogo,
  companyName,
}) => {
  // company_logo is sometimes a company homepage rather than an image file, which the
  // browser refuses to render (and logs as ERR_BLOCKED_BY_RESPONSE). Fall back to the
  // initials avatar instead of leaving a broken-image icon in the corner.
  const [logoFailed, setLogoFailed] = useState(false);
  useEffect(() => {
    setLogoFailed(false);
  }, [companyLogo]);
  const showLogo = Boolean(companyLogo) && !logoFailed;

  return (
    <div className="flex gap-2.5 w-full items-center">
      {/* user profile img with company img */}
      <div className="relative w-9 h-9">
        <div className="w-9 h-9 rounded-full overflow-hidden">
          <CommonAvatar
            imageUrl={UserImg}
            name={name}
            className="w-full h-full object-cover"
          />
        </div>
        {showLogo && (
          <img
            src={companyLogo}
            alt={companyName ? `${companyName} logo` : "Company logo"}
            onError={() => setLogoFailed(true)}
            className=" absolute w-4 h-4 rounded-full bottom-[1px] -right-1 border border-white"
          />
        )}
        {!showLogo && (
          <CommonAvatar
            imageUrl=""
            name={companyName}
            className="absolute w-4 h-4 rounded-full bottom-[1px] -right-1"
            textClassName="text-[7px] font-normal"
          />
        )}
      </div>
    </div>
  );
};

export default UserProfileWithCompany;
